import { environment } from '@src/environments';
import { EnvConfig } from '@src/environments/environment.interface';

export function getConfigClientFromRTE(): EnvConfig {
  return environment;
}
